<template>
  <a-result status="success" :title="title" sub-title="We will get back to you soon with the details to setup your GLS site.">
  </a-result>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      required: true,
    },
    validate: Boolean,
  },
  computed: {
    title() {
      return `Thanks ${this.company.contact.firstName}, You have Successfully Registered on GLS!`;
    }
  }
};
</script>

<style lang="scss">
</style>